/**
 * Person entities belonging to this node's super admins — the roster behind
 * the public Browse "Admins" tab. Unlike useSuperAdmins, this hits a plain,
 * ungated entities filter (GET /api/entities?admins_only=true) so every user,
 * not just other admins, can see who administers the node.
 *
 *   const { admins, loading, refresh } = useAdminPeople();
 */

import { useState, useEffect, useCallback } from 'react';
import { useApi } from './use_api';

export function useAdminPeople() {
    const api = useApi();
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        setLoading(true);
        return api.get('/api/entities', { params: { entity_type: 'person', admins_only: true } })
            .then(data => setAdmins(Array.isArray(data) ? data : []))
            .catch(() => setAdmins([]))
            .finally(() => setLoading(false));
    }, [api]);

    useEffect(() => { load(); }, [load]);

    return { admins, loading, refresh: load };
}

export default useAdminPeople;
